/**
 * Promotion Onboarding Selection and QA Maps
 * Maps pageKey to questions and answer options for Mixpanel User Properties tracking
 */

export const selectionMap: Record<string, Record<string, string[]>> = {
  goal_2: {
    "무엇을 기대하며 디스턴싱을 찾아오셨나요?": [
      "자신있고 주체적인 삶",
      "일상의 작은 행복을 만끽하는 삶",
      "사람들 속에서 편안하게 어울리는 삶",
      "하루하루를 생산적으로 보내는 삶",
      "스스로를 사랑하는 독립적인 삶",
      "평안하고 여유로운 마음을 가진 삶",
    ],
  },
  goal_3: {
    "우리의 마음은 여러 외부적 요인에 영향 받곤합니다. 다음 중 요즈음 나를 힘들게 하는 것이 있나요?": [
      "외부 환경의 변화 (진학, 이직 등)",
      "인간관계에서의 불화 또는 결별",
      "능률 저하 (학업, 업무 등)",
      "불확실한 미래 (진로, 취업 등)",
      "과거의 기억 또는 트라우마",
      "일정하지 않은 수면, 식사 패턴",
      "집착이나 중독 (게임, 코인, 음주, 쇼츠 등)",
      "기타",
    ],
  },
  goal_5: {
    "최근 들어 나의 일상을 흔드는 문제는 무엇인가요?": [
      "우울 (우울감, 무기력, 희망 없음)",
      "범불안 (만사 걱정)",
      "공황 (급격한 불안 공포)",
      "사회불안 (대인관계 불안)",
      "강박 (강박적인 생각과 행동)",
      "트라우마 (괴로운 과거 경험)",
      "분노 (분노 조절 문제)",
      "잘 모르겠음",
    ],
  },
  goal_6: {
    "앞선 문제들은 어떤 빈도로 찾아오곤 하나요?": [
      "하루에도 여러번",
      "하루에 한 번 정도",
      "2-3일에 한 번 정도",
      "일주일에 한 번 정도",
      "더 빈도가 적음",
    ],
  },
  goal_9: {
    "선호하는 프로그램 진행 속도가 있을까요?": [
      "최대한 빠르게",
      "보통의 속도",
      "부담없이 천천히",
    ],
  },
  motivation_2: {
    "건강한 마음을 향한 나의 바람은 어떻게 변해왔나요?": [
      "꾸준히 컸다",
      "컸다 작았다 한다",
      "어떤지 잘 모르겠다",
    ],
  },
  motivation_3: {
    "나는 쉽게 포기하기 때문에 외부적인 동기부여 장치가 필요하다": [
      "그렇다",
      "가끔 그렇다",
      "아니다",
    ],
  },
  motivation_5: {
    "프로그램에 대한 나의 마음은 어떠한가요?": [
      "잘 해낼 수 있다",
      "해볼만 한 것 같다",
      "아직 걱정이 많다",
    ],
  },
  motivation_7: {
    "건강한 마음을 갖는 것 외에, 내 삶에서 중요한 것은 무엇인가요?": [
      "배우자/연인",
      "부모/자식",
      "인간관계",
      "경력",
      "배움",
      "여가",
      "종교",
      "사회 기여",
      "기타",
    ],
  },
};

export const qaMap: Record<string, string[]> = {
  convention_2: [
    "내가 원하는 것은: 평온한 마음이다 vs. 건강한 라이프스타일이다.",
    "마음 관리 기술을 배우는 것은: 삶 전반에 영향을 준다 vs. 일부에만 영향을 준다",
    "내 마음이 안정적이라면: 스스로를 더 사랑할 것이다 vs. 그와 무관하게 사랑할 것이다",
    "내가 겪는 심리적 괴로움은: 항상 내 곁에 있다 vs. 특정한 트리거로 발생한다",
    "내 마음을 힘들게 하는 것은: 외적인 요인 때문이다 vs. 내적인 요인 때문이다",
    "건강한 마음을 갖는 것은: 삶의 궁극적인 목표다 vs. 삶의 여러 목표 중 하나다",
    "마음을 관리하고자 하는 나의 의지는: 항상 일정하게 유지된다 vs. 시간이 흐르며 들쑥날쑥하다",
    "마음이 건강하다는 것은: 고통을 잘 이겨낸다는 것이다 vs. 고통이 없다는 것이다",
    "멘탈케어 프로그램은 내게: 새로운 것을 알려줄 것이다 vs. 아무것도 알려주지 못할 것이다",
    "마음을 다스리는 법을 배우는 것은: 건강한 삶을 위해 필요하다 vs. 이미 방법을 아니 필요가 없다",
  ],
  habit_2: [
    "나는 지난 과거를 곱씹으며 답을 찾으려 애쓴다.",
    "나는 다가올 미래를 예측하고 대비하려 노력한다.",
    "나는 부정적인 생각이 들면 주의를 돌려 그것을 덮으려 한다.",
    "나는 특정 행동에 매달리며 부정적인 감정을 제거하려 한다.",
    "나는 부정적인 경험을 애초에 차단하고자 회피한다.",
  ],
};

export const qaAnswerMap: Record<string, string[]> = {
  convention_2: ["매우 동의(좌)", "동의(좌)", "동의(우)", "매우 동의(우)"],
  habit_2: ["아니다", "그렇다"],
};
